<template>
  <section class="page-hero">
    <div class="container">
      <div class="crumbs">
        <router-link to="/">Home</router-link><span>/</span>{{ title }}
      </div>
      <h1>{{ title }}</h1>
      <p v-if="lede">{{ lede }}</p>
    </div>
  </section>
</template>

<script>
export default {
    name: 'PageHero',
    props: { title: { type: String, required: true }, lede: String }
}
</script>
